import { SelectItem } from 'components/select/types';
import { TFunction } from 'i18next';
import { COUNTRY_LANGUAGE_MAP } from 'shared/constants';
import { Country, Language } from 'shared/types';
import { getLocaleString } from 'shared/utils/getLocaleString';
import { isLocaleAvailable } from 'shared/utils/isLocaleAvailable';

export const mapLanguages = (languages: Language[], countryCode: string): SelectItem[] => {
  const marketLanguages = COUNTRY_LANGUAGE_MAP[countryCode]?.sort(clm => clm.order);
  
  return marketLanguages.map(ml => {
    const language = languages.find(l => ml.languageCode === l.code);

    return {
      id: getLocaleString(language!.code, countryCode), 
      name: language!.name,
    };
  });
};

export const translateLangNamesToLocalLang = (
  t: TFunction,
  languages: Language[],
  selectedCountryCode: string
) => {
  return languages.map((language) => {
    const translatedName = t(`languageSelect.localLanguage`, {
      lng: getLocaleString(language.code, selectedCountryCode),
    });
    return { ...language, name: translatedName };
  });
};

export const updatePathOnLanguageChange = (
  languageAndCountry: string,
  languages: Language[],
  countries?: Country[]
) => {
  const pathname = window.location.pathname;
  const firstPathEl = pathname.split('/')[1];
  const hasLangInPath = isLocaleAvailable(firstPathEl, languages, countries);

  let newPath = pathname;

  if (hasLangInPath) {
    // if has a locale in path, and it's a valid one switch it to the new one
    newPath = pathname.replace(firstPathEl, `${languageAndCountry}`);
  } else {
    // if not, just switch to the new value
    newPath = `/${languageAndCountry}${pathname.length > 1 ? pathname : ''}`;
  }
  
  window.location.replace(newPath);
};
